<template>
    <div
        class="xmoFilterContent__tooltipContent"
        tabindex="0">
        <span>
            {{ groupName }}
        </span>
        <hr />
        <ul>
            <li
                v-for="(childCountry, childCountryIndex) in subRegions"
                :key="`${ childCountry.id }--${ childCountryIndex }`">
                {{ childCountry.name }}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            subRegions: {
                type: [Object, Array],
                required: true,
            },
            groupName: {
                type: String,
                default: '',
            },
        },
    };
</script>
